import { inject as P, computed as b, ref as C, onMounted as N, onUnmounted as O, openBlock as a, createElementBlock as i, normalizeClass as k, createElementVNode as r, toDisplayString as z, createCommentVNode as h, createVNode as L, reactive as V, watch as W, normalizeStyle as D, nextTick as I, Fragment as g, renderList as S, withDirectives as G, vShow as U, resolveComponent as X, withCtx as J, createBlock as x, provide as Z } from "vue";
const E = [
  { name: "None", value: "", light: !0 },
  { name: "Primary", value: "#6F43D6", light: !1 },
  { name: "Primary light", value: "#C5B4EF", light: !0 },
  { name: "Primary dark", value: "#4316AC", light: !1 },
  { name: "Black", value: "#000", light: !1 },
  { name: "Dark gray", value: "#666", light: !1 },
  { name: "Medium Gray", value: "#A6A6A6", light: !1 },
  { name: "Gray", value: "#ccc", light: !0 },
  { name: "Light Gray", value: "#e3e3e3", light: !0 },
  { name: "XX Light Gray", value: "#FBFBFB", light: !0 },
  { name: "XXX Light Gray", value: "#FEFEFE", light: !0 },
  { name: "White", value: "#fff", light: !0 }
], K = E.filter((e) => e.light).map((e) => e.value), Q = ["#fff", ""], Y = {
  colors: E,
  white: Q,
  lights: K
}, { lights: ee } = Y, q = () => ({
  name: "Background Color",
  id: "bgcolor",
  type: "color",
  default: ""
}), y = () => ({
  name: "Max width",
  id: "maxwidth",
  type: "droplist",
  default: "width-full",
  choices: [{ name: "900px", value: "width-narrow" }, { name: "1140px", value: "width-med" }, { name: "1300px", value: "width-normal" }, { name: "1440px", value: "width-wide" }, { name: "Full width", value: "width-full" }]
}), R = () => ({
  name: "Aspect Ratio",
  id: "aspectratio",
  type: "droplist",
  default: "",
  choices: [
    { name: "Widescreen 16:9", value: "" },
    { name: "Standard 4:3", value: "video-standard" },
    { name: "Vertical 9:16", value: "video-vertical" },
    { name: "Square 1:1", value: "video-square" }
  ]
}), _ = {
  breadcrumbs: {
    name: "Breadcrumbs",
    menu: !0,
    learn: !1,
    settings: [
      q(),
      y(),
      {
        name: "Align",
        id: "alignment",
        type: "droplist",
        default: "left",
        choices: [{ name: "left", value: "left" }, { name: "center", value: "center" }, { name: "right", value: "right" }]
      }
    ],
    elements: []
  },
  headline: {
    name: "Headline",
    menu: !0,
    learn: !0,
    settings: [
      q(),
      y(),
      {
        name: "Background Image",
        id: "bgimage",
        type: "image-picker"
      }
    ],
    elements: [
      {
        id: "text",
        type: "quill",
        default: '<h2 class="ql-align-center">Headline</h2><p class="ql-align-center">Body copy</p>'
      }
    ]
  },
  justimage: {
    name: "Single Image",
    menu: !0,
    learn: !0,
    settings: [
      y(),
      {
        name: "Image Type",
        id: "imshape",
        type: "droplist",
        default: "image-fit",
        choices: [{ name: "Original Image Shape", value: "image-fit" }, { name: "Square", value: "square" }, { name: "Round", value: "round" }]
      }
    ],
    elements: []
  },
  imageplustext: {
    name: "Image + text",
    menu: !0,
    learn: !0,
    settings: [
      y(),
      {
        name: "Image Position",
        id: "impos",
        type: "droplist",
        default: "impos-left",
        choices: [{ name: "Left", value: "impos-left" }, { name: "Right", value: "impos-right" }]
      },
      {
        name: "Image width",
        id: "imwidth",
        type: "droplist",
        default: "half",
        choices: [{ name: "50%", value: "half" }, { name: "30%", value: "third" }]
      },
      {
        name: "Style",
        id: "box-style",
        default: "box-style-normal",
        type: "droplist",
        choices: [{ name: "Normal", value: "box-style-normal" }, { name: "Alternating Squares", value: "box-style-alt" }]
      },
      {
        name: "Image",
        id: "image",
        type: "image-picker"
      }
    ],
    elements: [
      {
        id: "text",
        type: "quill",
        default: "<p>Text goes here...</p>"
      }
    ]
  },
  copy: {
    name: "Text Block",
    menu: !0,
    learn: !0,
    settings: [
      q(),
      y(),
      {
        name: "Bullet list spacing",
        id: "listspace",
        type: "droplist",
        default: "normal",
        choices: [{ name: "normal", value: "ls-normal" }, { name: "wide", value: "ls-wide" }, { name: "very wide", value: "ls-xwide" }]
      }
    ],
    elements: [
      {
        id: "text",
        type: "quill",
        default: "<p>Body copy...</p>"
      }
    ]
  },
  htmlmodule: {
    name: "Raw HTML",
    menu: !0,
    learn: !0,
    settings: [
      y()
    ],
    elements: [
      {
        id: "text",
        type: "html",
        default: "<p>HTML Editor...</p>"
      }
    ]
  },
  spacer: {
    name: "Spacer/Divider",
    menu: !0,
    learn: !0,
    settings: [
      {
        name: "Spacer Height",
        id: "height",
        type: "droplist",
        default: "spacer-height-large",
        choices: [
          { name: "Small", value: "height-small" },
          { name: "Medium", value: "height-medium" },
          { name: "Large", value: "height-large" }
        ]
      },
      {
        name: "Divider Line",
        id: "divider",
        type: "bool",
        default: !1
      },
      q(),
      y()
    ],
    elements: [
      {
        id: "line",
        type: "html"
      }
    ]
  },
  xvideo: {
    name: "External Video",
    menu: !0,
    learn: !0,
    settings: [
      {
        name: "Video Url",
        id: "url",
        type: "text",
        default: ""
      },
      {
        name: "Autoplay",
        id: "autoplay",
        type: "bool",
        default: !1
      },
      y(),
      R()
    ],
    elements: [
      {
        id: "video",
        type: "html"
      }
    ]
  },
  ivideo: {
    name: "Uploaded Video",
    menu: !0,
    learn: !0,
    settings: [
      {
        name: "Video",
        id: "url",
        type: "file-picker",
        filetypes: ["mp4"],
        default: ""
      },
      {
        name: "Autoplay",
        id: "autoplay",
        type: "bool",
        default: !1
      },
      {
        name: "Show controls",
        id: "controls",
        type: "bool",
        default: !0
      },
      y(),
      R()
    ],
    elements: [
      {
        id: "video",
        type: "html"
      }
    ]
  },
  pdf: {
    name: "Embedded PDF",
    menu: !0,
    learn: !0,
    settings: [
      {
        name: "PDF",
        id: "url",
        type: "file-picker",
        filetypes: ["pdf"],
        default: ""
      },
      y(),
      {
        name: "Aspect Ratio",
        id: "aspectratio",
        type: "droplist",
        default: "",
        choices: [
          { name: "Letter Portrait", value: "pdf-letter-portrait" },
          { name: "A4 Portrait", value: "pdf-a4-portrait" },
          { name: "Square 1:1", value: "pdf-square" },
          { name: "Letter Landscape", value: "pdf-letter-landscape" },
          { name: "A4 Landscape", value: "pdf-a4-landscape" }
        ]
      }
    ],
    elements: [
      {
        id: "pdf",
        type: "html"
      }
    ]
  },
  tabs: {
    name: "Tabbed Navigation",
    menu: !0,
    learn: !0,
    settings: [
      {
        name: "No. of tabs",
        id: "numcols",
        type: "droplist",
        default: 3,
        choices: [
          { name: "2 tabs", value: 2 },
          { name: "3 tabs", value: 3 },
          { name: "4 tabs", value: 4 },
          { name: "5 tabs", value: 5 },
          { name: "6 tabs", value: 6 },
          { name: "7 tabs", value: 7 },
          { name: "8 tabs", value: 8 },
          { name: "9 tabs", value: 9 }
        ]
      },
      {
        name: "Style",
        id: "tabstyle",
        type: "droplist",
        default: "purple",
        choices: [
          { name: "Purple tabs with images", value: "ts-purple" },
          { name: "Gray button tabs", value: "ts-gray" },
          { name: "Horizontal with arrows", value: "ts-horz" }
        ]
      },
      y()
    ],
    elements: [
      {
        id: "tabs",
        type: "tab",
        repeat: "numcols"
      },
      {
        id: "columns",
        type: "tabcol",
        repeat: "numcols"
      }
    ]
  },
  columns: {
    name: "Column Layout",
    menu: !0,
    learn: !0,
    settings: [
      {
        name: "Columns",
        id: "numcols",
        type: "droplist",
        default: 2,
        choices: [
          { name: "2 columns", value: 2 },
          { name: "3 columns", value: 3 },
          { name: "4 columns", value: 4 }
        ]
      },
      {
        name: "Image Type",
        id: "imshape",
        type: "droplist",
        default: "square",
        choices: [{ name: "Square", value: "square" }, { name: "Round", value: "round" }, { name: "No images", value: "textonly" }]
      },
      y()
    ],
    elements: [
      {
        id: "columns",
        type: "imagecol",
        repeat: "numcols"
      }
    ]
  },
  quill: {
    name: "Legacy Wysiwyg",
    settings: [],
    elements: [
      {
        id: "text",
        type: "quill",
        default: "<p>Wysiwyg copy...</p>"
      }
    ]
  },
  classic: {
    name: "Legacy Classic",
    settings: [],
    elements: [
      {
        id: "text",
        type: "classic",
        default: "<p>Classic body copy...</p>"
      }
    ]
  }
};
function F(e, n) {
  return Object.keys(e).filter((t) => e[t][n] === !0).reduce((t, l) => (t[l] = e[l], t), {});
}
const te = F(_, "menu"), et = Object.keys(te).map((e) => ({
  name: _[e].name || e,
  value: e
})), ne = F(_, "learn"), tt = Object.keys(ne).map((e) => ({
  name: _[e].name || e,
  value: e
})), ae = ["maxwidth", "height", "aspectratio", "imshape", "imwidth", "impos", "box-style", "alignment", "tabstyle", "listspace"], le = (e) => {
  const n = [];
  ee.includes(e.bgcolor) && n.push("light");
  for (let t of ae)
    e[t] && n.push(e[t]);
  return e.divider && n.push("divider"), e.numcols && n.push("cols" + e.numcols), e.textonly && n.push("textonly"), n;
}, nt = (e, n) => {
  if (!_[n])
    throw "No module definition for " + n;
  for (let t of _[n].settings)
    e[t.id] === void 0 && t.default !== void 0 && (e[t.id] = t.default);
  for (let t of _[n].elements)
    t.default !== void 0 && e[t.id] === void 0 && (e[t.id] = t.default);
}, ie = ["src", "alt"], H = {
  __name: "JsonImagePreview",
  props: { image: [Object, String] },
  setup(e) {
    const n = e, t = P("navigate");
    function l(B) {
      for (let c of T)
        if (c > B)
          return c;
      return 1600;
    }
    function d(B) {
      for (let c of B)
        if (c.contentRect) {
          const $ = Math.max(c.contentRect.width, c.contentRect.height);
          o.value = l($);
        }
    }
    const p = b(() => o.value < 640);
    function f() {
      A.value && n.image && n.image.Link && t(n.image.Link);
    }
    let m = null;
    const u = C(null), o = C(250), T = [400, 600, 800, 1200, 1400, 1600];
    N(() => {
      m = new ResizeObserver(d), u.value && m.observe(u.value);
    }), O(() => {
      m && u.value && m.unobserve(u.value), m = null;
    });
    const w = b(() => n.image ? `/imgsz/${o.value}/${n.image.Filename}` : ""), A = b(() => n.image && n.image.Link);
    return (B, c) => e.image ? (a(), i("div", {
      key: 0,
      class: k(["json-image", { linked: A.value }]),
      ref_key: "base",
      ref: u,
      onClick: f
    }, [
      r("img", {
        src: w.value,
        alt: e.image.Alt
      }, null, 8, ie),
      e.image.Description ? (a(), i("div", {
        key: 0,
        class: k(["caption", { hir: p.value }])
      }, z(e.image.Description), 3)) : h("", !0)
    ], 2)) : h("", !0);
  }
}, se = {
  key: 0,
  class: "json-column"
}, oe = {
  key: 0,
  class: "json-text"
}, re = ["innerHTML"], ue = {
  __name: "ColumnPreview",
  props: { content: Object },
  setup(e) {
    return (n, t) => e.content ? (a(), i("div", se, [
      L(H, {
        image: e.content.image
      }, null, 8, ["image"]),
      e.content.text ? (a(), i("div", oe, [
        r("div", {
          innerHTML: e.content.text
        }, null, 8, re)
      ])) : h("", !0)
    ])) : h("", !0);
  }
}, j = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [l, d] of n)
    t[l] = d;
  return t;
}, ce = {}, me = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
}, de = /* @__PURE__ */ r("path", { d: "M480-360 280-560h400L480-360Z" }, null, -1), fe = [
  de
];
function he(e, n) {
  return a(), i("svg", me, fe);
}
const ge = /* @__PURE__ */ j(ce, [["render", he]]), pe = {}, ve = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
}, ye = /* @__PURE__ */ r("path", { d: "m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" }, null, -1), be = [
  ye
];
function we(e, n) {
  return a(), i("svg", ve, be);
}
const xe = /* @__PURE__ */ j(pe, [["render", we]]), ke = { class: "expando-content" }, _e = ["innerHTML"], $e = ["innerHTML"], Te = {
  __name: "ExpandoItem",
  props: { content: String, open: Boolean },
  setup(e) {
    const n = e, t = P("waitfor"), l = V({
      opening: !1,
      style: { height: "0px" }
    }), d = C(null), p = C(null);
    async function f() {
      if (n.open) {
        l.style.height = "0px", l.opening = !0, await I();
        const m = p.value.getBoundingClientRect();
        l.style.height = m.height + "px", l.opening = !1, await t(300), await I(), l.style.height = "auto", console.log("I have opened");
      } else {
        const m = d.value.getBoundingClientRect();
        l.style.height = m.height + "px", await t(100), await I(), l.style.height = "0px", console.log("I have closed");
      }
    }
    return W(
      () => n.open,
      () => {
        f();
      }
    ), (m, u) => (a(), i("div", {
      class: k(["expando", { open: e.open }]),
      ref_key: "basel",
      ref: d,
      style: D(l.style)
    }, [
      r("div", ke, [
        r("div", { innerHTML: e.content }, null, 8, _e)
      ]),
      r("div", {
        class: k(["measurable", { viz: l.opening }]),
        ref_key: "mes",
        ref: p
      }, [
        r("div", { innerHTML: e.content }, null, 8, $e)
      ], 2)
    ], 6));
  }
}, Le = /* @__PURE__ */ j(Te, [["__scopeId", "data-v-3d2cb366"]]), Se = { key: 0 }, Ce = ["onClick"], Be = { class: "json-tab-title" }, Me = ["innerHTML"], je = { class: "tab-prong" }, qe = { class: "json-tab-body" }, He = ["onClick"], Ae = ["innerHTML"], Ie = { class: "drop-icon" }, Re = { class: "json-text" }, Pe = ["innerHTML"], ze = {
  __name: "TabsPreview",
  props: { content: Object },
  setup(e) {
    const n = e, t = C(0), l = C(null);
    n.content.tabstyle === "ts-horz" && (t.value = -1);
    const d = b(() => n.content.tabstyle === "ts-horz");
    function p(f) {
      if (d.value && t.value === f) {
        t.value = -1;
        return;
      }
      t.value !== f && (t.value = f, l.value && l.value.blur());
    }
    return (f, m) => (a(), i("div", null, [
      d.value ? (a(), i("div", Se, [
        (a(!0), i(g, null, S(e.content.tabs, (u, o) => (a(), i("div", {
          class: k(["json-tab", { sel: t.value === o }]),
          key: "tab" + o,
          onClick: (T) => p(o)
        }, [
          r("div", Be, [
            r("div", {
              innerHTML: u.text
            }, null, 8, Me),
            r("div", je, [
              L(xe)
            ])
          ]),
          r("div", qe, [
            L(Le, {
              content: e.content.columns[o].text,
              open: t.value === o
            }, null, 8, ["content", "open"])
          ])
        ], 10, Ce))), 128))
      ])) : (a(), i(g, { key: 1 }, [
        r("div", {
          class: "tabs",
          tabindex: "30",
          ref_key: "metabs",
          ref: l
        }, [
          (a(!0), i(g, null, S(e.content.tabs, (u, o) => (a(), i("div", {
            class: k(["json-tab", { sel: t.value === o }]),
            key: "tab" + o,
            onClick: (T) => p(o)
          }, [
            r("div", {
              innerHTML: u.text
            }, null, 8, Ae),
            r("div", Ie, [
              L(ge)
            ])
          ], 10, He))), 128))
        ], 512),
        (a(!0), i(g, null, S(e.content.columns, (u, o) => G((a(), i("div", {
          class: "tab-area",
          key: "col-" + o
        }, [
          r("div", Re, [
            r("div", {
              innerHTML: u.text
            }, null, 8, Pe)
          ]),
          L(H, {
            image: u.image
          }, null, 8, ["image"])
        ])), [
          [U, o === t.value]
        ])), 128))
      ], 64))
    ]));
  }
}, De = /* @__PURE__ */ j(ze, [["__scopeId", "data-v-b23e7276"]]);
class v {
  constructor(n, t = null) {
    this.name = n, this.mapTo = t || n;
  }
}
class s {
  constructor(n, t, l, ...d) {
    this.tagName = n, this.openTag = t, this.closeTag = l, this.attributes = d;
  }
  apply(n) {
    let t;
    const l = new RegExp(`\\[${this.tagName}(=[^\\]]+)?\\](.*?)\\[\\/${this.tagName}\\]`, "gi");
    do
      t = n, n = n.replace(l, (d, p, f) => {
        let m = this.openTag, u = {};
        if (p) {
          const o = p.split("=")[1].replace(/["']/g, "");
          this.attributes.length > 0 && (u[this.attributes[0].name] = o);
        }
        return this.attributes.forEach((o) => {
          const T = u[o.name] || "";
          m = m.replace(`\${${o.mapTo}}`, T);
        }), `${m}${f}${this.closeTag}`;
      });
    while (n !== t);
    return n;
  }
}
const Ee = [
  new s("b", "<b>", "</b>"),
  new s("white", "<span style='color:#fff'>", "</span>"),
  new s("purple", "<span style='color:purple'>", "</span>"),
  new s("red", "<span style='color:#ff0000'>", "</span>"),
  new s("blue", "<span style='color:#0000bb'>", "</span>"),
  new s("i", '<span style="font-style:italic;">', "</span>"),
  new s("u", '<span style="text-decoration:underline;">', "</span>"),
  new s("code", '<pre class="prettyprint">', "</pre>"),
  new s("img", '<img src="${content}" />', "", !1, !0),
  new s("quote", "<blockquote>", "</blockquote>"),
  new s("list", "<ul>", "</ul>"),
  new s("olist", "<ol>", "</ol>"),
  new s("caption", "<div class='caption'><p>", "</p></div>"),
  new s("twocol", "<div class='two-column'>", "</div>"),
  new s("*", "<li>", "</li>", !0, !1),
  new s("url", '<a href="${href}">', "</a>", new v("href", ""), new v("href", "href")),
  new s("urlpop", '<a href="${href}" target="_blank">', "</a>", new v("href", ""), new v("href", "href")),
  new s("br", "<br/>", "", !0, !1),
  new s("pdf", `<object data="\${href}#view=FitH" type='application/pdf' width='660px' height='800px'><a href="\${href}">`, "</a></object>", new v("href")),
  new s("button", `<a class='tk-pbutton' href="\${href}">`, "</a>", new v("href", ""), new v("href", "href")),
  new s("buttonpop", `<a class='tk-pbutton' href="\${href}" target="_blank">`, "</a>", new v("href", ""), new v("href", "href")),
  new s("reveal", `<a class='tk-reveal' href="#" onclick='showArticle(\${aref});return false'>`, "</a>", new v("aref", ""), new v("aref", "aref")),
  new s("alert", "<div class='alert-notice'>", "</div>"),
  new s("heading", "<h2>", "</h2>"),
  new s("comment", "<!-- ", " -->"),
  new s("embed", `<div class='article-embed' data-id="\${id}">`, "</div>", new v("id", ""), new v("id", "id"))
];
function Fe(e) {
  return e ? (e.indexOf("[") < 0 || (console.log("doing tags"), Ee.forEach((n) => {
    e = n.apply(e);
  })), e) : "";
}
const Ne = ["innerHTML"], M = {
  __name: "TextDiv",
  props: { text: String },
  setup(e) {
    const n = e, t = b(() => Fe(n.text));
    return (l, d) => (a(), i("div", { innerHTML: t.value }, null, 8, Ne));
  }
}, Oe = ["innerHTML"], Ve = {
  key: 1,
  class: "bg-image"
}, We = ["src"], Ge = { class: "imp-text" }, Ue = {
  key: 5,
  class: "json-text"
}, Xe = { key: 1 }, Je = {
  __name: "ModulePreview",
  props: { module: Object, breadcrumbs: Array },
  setup(e) {
    const n = ["tabs", "imageplustext", "justimage", "raw", "classic", "quill", "rawlines", "breadcrumbs"], t = ["raw", "classic", "quill", "rawlines"], l = e, d = ["quill", "html", "classic"], p = b(() => _[l.module.format] ? _[l.module.format].elements : []);
    function f(w) {
      return typeof w == "string";
    }
    const m = b(() => {
      const w = [];
      return l.module.content.bgcolor && w.push({ backgroundColor: l.module.content.bgcolor }), w;
    }), u = b(() => {
      const w = le(l.module.content);
      return w.push(l.module.format), w;
    }), o = b(() => l.module.content ? typeof l.module.content == "string" : !1), T = b(() => {
      if (o.value) {
        if (l.module.content.text)
          return l.module.content.text.includes('<div class="workbench-import">');
        if (typeof l.module.content == "string")
          return l.module.content.includes('<div class="workbench-import">');
      }
      return !1;
    });
    return (w, A) => {
      const B = X("router-link");
      return a(), i("div", {
        class: k(["json-module", u.value]),
        style: D(m.value)
      }, [
        T.value ? (a(), i("div", Xe, "Unable to preview Workbench files")) : (a(), i(g, { key: 0 }, [
          e.module.format === "breadcrumbs" ? (a(!0), i(g, { key: 0 }, S(e.breadcrumbs, (c, $) => (a(), i("div", {
            key: $ + "crumb"
          }, [
            L(B, {
              to: c.link
            }, {
              default: J(() => [
                r("span", {
                  innerHTML: c.text
                }, null, 8, Oe)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))), 128)) : h("", !0),
          e.module.content.bgimage ? (a(), i("div", Ve, [
            r("img", {
              src: `/imgsz/1200/${e.module.content.bgimage.Filename}`
            }, null, 8, We)
          ])) : h("", !0),
          e.module.format === "tabs" ? (a(), x(De, {
            key: 2,
            content: e.module.content
          }, null, 8, ["content"])) : h("", !0),
          e.module.format === "imageplustext" ? (a(), i(g, { key: 3 }, [
            e.module.content.image ? (a(), x(H, {
              key: 0,
              image: e.module.content.image,
              class: "imp-image"
            }, null, 8, ["image"])) : h("", !0),
            r("div", Ge, [
              L(M, {
                text: e.module.content.text
              }, null, 8, ["text"])
            ])
          ], 64)) : h("", !0),
          e.module.format === "justimage" ? (a(), i(g, { key: 4 }, [
            e.module.content.image ? (a(), x(H, {
              key: 0,
              image: e.module.content.image,
              class: "imp-image"
            }, null, 8, ["image"])) : h("", !0)
          ], 64)) : h("", !0),
          t.includes(e.module.format) ? (a(), i("div", Ue, [
            typeof e.module.content == "string" ? (a(), x(M, {
              key: 0,
              text: e.module.content
            }, null, 8, ["text"])) : (a(), x(M, {
              key: 1,
              text: e.module.content.text
            }, null, 8, ["text"]))
          ])) : h("", !0),
          n.includes(e.module.format) ? h("", !0) : (a(), i(g, { key: 6 }, [
            e.module.content.columns ? (a(!0), i(g, { key: 0 }, S(e.module.content.columns, (c, $) => (a(), x(ue, {
              key: "i" + $,
              content: e.module.content.columns[$]
            }, null, 8, ["content"]))), 128)) : (a(), i(g, { key: 1 }, [
              (a(!0), i(g, null, S(p.value, (c, $) => (a(), i(g, {
                key: "el" + $
              }, [
                d.includes(c.type) && f(e.module.content[c.id]) ? (a(), x(M, {
                  key: 0,
                  class: k(c.id),
                  text: e.module.content[c.id],
                  render: "true",
                  "data-etype": c.type
                }, null, 8, ["class", "text", "data-etype"])) : (a(), i("div", {
                  key: 1,
                  class: k(c.id)
                }, z(e.module.content[c.id]), 3))
              ], 64))), 128)),
              o.value ? (a(), i(g, { key: 0 }, [
                typeof e.module.content == "string" ? (a(), x(M, {
                  key: 0,
                  text: e.module.content
                }, null, 8, ["text"])) : h("", !0)
              ], 64)) : h("", !0)
            ], 64))
          ], 64))
        ], 64))
      ], 6);
    };
  }
}, Ze = { class: "glib-article-preview" }, Ke = {
  __name: "ArticlePreview",
  props: { article: String, format: String, breadcrumbs: Array },
  emits: ["navigate"],
  setup(e, { emit: n }) {
    const t = e, l = n, d = b(() => {
      if (t.format === "json" && t.article)
        try {
          return JSON.parse(t.article);
        } catch (f) {
          return console.log("parsing error", f.message, "probably because we are changing formats"), [{ format: "copy", content: { text: t.article } }];
        }
      return [{ format: t.format, content: { text: t.article } }];
    });
    function p(f) {
      l("navigate", f);
    }
    return Z("navigate", p), (f, m) => (a(), i("div", Ze, [
      (a(!0), i(g, null, S(d.value, (u) => (a(), x(Je, {
        key: u.id,
        module: u,
        breadcrumbs: e.breadcrumbs
      }, null, 8, ["module", "breadcrumbs"]))), 128))
    ]));
  }
}, at = /* @__PURE__ */ j(Ke, [["__scopeId", "data-v-02357bc5"]]), Qe = /* @__PURE__ */ r("div", null, "Simple Test", -1), lt = {
  __name: "SimpleTest",
  setup(e) {
    const n = C(null);
    return (t, l) => (a(), i("div", null, [
      Qe,
      r("div", {
        ref_key: "meref",
        ref: n
      }, "Oh noes a ref", 512)
    ]));
  }
};
console.log("getty-lib v.1.1");
export {
  at as ArticlePreview,
  H as JsonImagePreview,
  lt as SimpleTest,
  Fe as applyBBCode,
  le as calculateStyleClasses,
  Y as color,
  nt as createDefaultSettings,
  _ as defs,
  tt as learnModules,
  et as modules
};
//# sourceMappingURL=getty-lib.es.js.map
